/**
 * B552 leg (c1) — the client error sink: a crashed page has no token to
 * present, so the door is PUBLIC and every wall lives behind it (the
 * domain's per-source rate limit, masking and bounds; the membrane's
 * audit row). The response is deliberately tiny: the ref the client may
 * show beside its error face, and nothing a probe could farm.
 */
import { z } from "zod";
import { publicOp, zId } from "./common.js";

export const CLIENT_ERROR_KINDS = ["crash", "unhandled", "api", "network", "contract"] as const;

export const CLIENT_ERROR_APPS = [
  "admin",
  "operator",
  "storefront",
  "embed",
  "pos",
  "validator",
  "kiosk",
  "pos-android",
  "validator-android",
  "storefront-ios",
  "storefront-android",
] as const;

export const clientErrorReport = publicOp({
  name: "client.error.report",
  permission: "public",
  fields: {
    app: z.enum(CLIENT_ERROR_APPS),
    kind: z.enum(CLIENT_ERROR_KINDS),
    message: z.string().min(1).max(2_000),
    appVersion: z.string().min(1).max(60).optional(),
    route: z.string().min(1).max(400).optional(),
    deviceId: zId.optional(),
    stack: z.string().min(1).max(16_000).optional(),
    breadcrumbs: z.array(z.string().min(1).max(400)).max(40).optional(),
    lastRequestId: z.string().min(1).max(80).optional(),
    userAgent: z.string().min(1).max(500).optional(),
  },
  response: z.object({ reportId: zId, receivedAt: z.number().int() }).strict(),
  exampleRequest: { app: "storefront", kind: "unhandled", message: "TypeError: x is not a function" },
  exampleResponse: { reportId: "ce-1", receivedAt: 1_780_000_000_000 },
});
